import { render, staticRenderFns } from "./PortfolioItem.vue?vue&type=template&id=b811a100&scoped=true&"
import script from "./PortfolioItem.vue?vue&type=script&lang=js&"
export * from "./PortfolioItem.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioItem.vue?vue&type=style&index=0&id=b811a100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b811a100",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VDialog,VDivider,VIcon,VOverlay})
